import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';

interface SaveBarErrorProps {
    message: string;
    actionText?: string;
    onAction?: () => void;
    showIcon?: boolean;
}

export const SaveBarError = ({
    message,
    actionText,
    onAction,
    showIcon = true,
}: SaveBarErrorProps) => (
    <Box
        display="flex"
        alignItems="center"
        sx={{
            color: 'text.primary',
            fontSize: '13px',
            fontWeight: 400,
            lineHeight: '12px',
        }}
    >
        {showIcon && (
            <ErrorOutlineIcon
                sx={{
                    color: 'error.main',
                    marginRight: '8px',
                }}
            />
        )}
        {actionText && onAction && (
            <Typography
                component="span"
                onClick={onAction}
                sx={{
                    color: 'primary.main',
                    fontSize: '13px',
                    fontWeight: 400,
                    lineHeight: '12px',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                }}
            >
                {actionText}
            </Typography>
        )}
        {actionText && onAction && <>&nbsp;</>}
        {message}
    </Box>
);
